import React, { useState, useMemo } from 'react';
import { LangType } from '../typings/lang';
import { useFeatureServices } from '../hooks/use-feature-services';

import { MyVwContextType } from '../typings/main';
import { MyVwContext } from '../hooks/use-my-vw-context';
import { translation } from '../../lang/translation';

const mapToLangType = (language: string, countryCode: string): LangType => {
  const lang = language.toLowerCase();
  const country = countryCode.toUpperCase();

  if (country === 'CA' && lang === 'en') {
    return 'en-ca';
  }

  if (country === 'CA' && lang === 'fr') {
    return 'fr';
  }

  return 'en';
};

export const MyVwContextProvider = ({
  children,
  service,
  baseUrl,
}: {
  children: React.ReactNode;
  service: any;
  baseUrl?: string,
}) => {
  const { 'locale-service': localeService } = useFeatureServices();

  const initialLang = useMemo(() => {
    return mapToLangType(
      localeService.language || 'en',
      localeService.countryCode || 'US'
    );
  }, [localeService.language, localeService.countryCode]);

  const [lang, setLang] = useState<LangType>(initialLang);

  const translationHandler = (key: string): string => {
    return translation(lang, key);
  };

  const myVwContextValue: MyVwContextType = {
    translationHandler,
    lang: {
      value: lang,
      set: setLang,
    },
    authService: service,
    baseUrl: baseUrl,
  };

  return (
    <MyVwContext.Provider value={myVwContextValue}>
      {children}
    </MyVwContext.Provider>
  );
};
